import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ReachOutToUs from "./sections/ReachOutToUs";
import OurServiceAreas from "./sections/OurServiceAreas";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ReachOutToUs />
      <OurServiceAreas />
      <Footer />
    </div>;
}